<template>
  <section id="op-loading" :class="kioShow ? 'op-show' : 'op-hide'">
    <div class="loading-content">
      <Spin size="large" fix>
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>Loading...</div></Spin
      >
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      kioShow: true
    };
  },
  watch: {
    kioShow(val) {}
  }
};
</script>
<style lang="less">
#op-loading {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 1);
  z-index: 9;
  font-size: 18px;
  .loading-content {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-spin-fix {
      height: auto;
      position: relative;
    }
  }
  &.op-show {
    opacity: 1;
    pointer-events: auto;
    transition: all 1s;
  }
  &.op-hide {
    opacity: 0;
    pointer-events: none;
    transition: all 1s;
  }
  .demo-spin-icon-load {
    font-size: 30px !important;
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
}
</style>
